import { jsxs as oe, jsx as b, Fragment as rr } from "react/jsx-runtime";
import * as P from "react";
import _n, { forwardRef as En, useState as wt, useRef as or, useCallback as Pe, useEffect as Et } from "react";
import { c as Ot, I as xt } from "./Section-DOeCOW54.js";
import { T as Ue, u as Pn, B as Yt } from "./useMediaQuery-BZAMobKw.js";
import { C as ir } from "./Chip-D9KeDlTM.js";
import { c as ht } from "./_commonjsHelpers-DaMA6jEr.js";
import { P as m, g as ar, a as sr, c as Tn, H as Dt, o as Jt, b as lr, u as en, d as tn, e as cr, f as ur, h as fr, i as gt, s as pr } from "./Modal-DQnpXu98.js";
import { I as Nt, A as dr, O as mr, b as hr, a as gr, c as vr, M as br, G as yr, m as wr, u as Or, S as xr } from "./ApartmentCard-BfyZfamk.js";
import { B as _r } from "./BuildingCard-DK7g1PNq.js";
const kt = {
  "filter-button": "elo-filter-button",
  "filter-button--selected": "elo-filter-button--selected",
  "filter-button__label": "elo-filter-button__label"
}, Er = _n.forwardRef(
  ({ icon: e = "Corporate", selected: t = !1, focussed: n = !1, label: r, ...o }, i) => {
    const l = Ot(
      kt["filter-button"],
      {
        [kt["filter-button--selected"]]: t
      },
      o.className
    );
    return /* @__PURE__ */ oe(
      "button",
      {
        ...o,
        ref: i,
        className: l,
        "data-focus": n,
        children: [
          /* @__PURE__ */ b("div", { children: /* @__PURE__ */ b(xt, { name: e }) }),
          /* @__PURE__ */ b(
            Ue,
            {
              type: "span",
              size: "medium",
              extraClass: kt["filter-button__label"],
              children: r
            }
          )
        ]
      }
    );
  }
), Ee = {
  "filter-tag": "elo-filter-tag",
  "filter-tag__text": "elo-filter-tag__text",
  "filter-tag__button": "elo-filter-tag__button",
  "filter-tag__button__icon": "elo-filter-tag__button__icon",
  "filter-tag__button__close-icon": "elo-filter-tag__button__close-icon"
}, sa = En(
  ({ tag: e, lastTagText: t, onRemoveTag: n, onRemoveAllTags: r, icon: o }, i) => t && r ? /* @__PURE__ */ b("div", { ref: i, className: Ee["filter-tag"], children: /* @__PURE__ */ b(
    "button",
    {
      className: Ee["filter-tag__button"],
      onClick: r,
      "aria-label": "Remove all tags",
      children: /* @__PURE__ */ b(
        Ue,
        {
          type: "paragraph",
          size: "small",
          extraClass: Ee["filter-tag__text"],
          children: t
        }
      )
    }
  ) }) : /* @__PURE__ */ oe("div", { ref: i, className: Ee["filter-tag"], children: [
    o ? /* @__PURE__ */ b(xt, { name: o, className: Ee["filter-tag__button__icon"] }) : null,
    /* @__PURE__ */ b(
      Ue,
      {
        type: "paragraph",
        size: "small",
        extraClass: Ee["filter-tag__text"],
        children: e
      }
    ),
    /* @__PURE__ */ b(
      "button",
      {
        className: Ee["filter-tag__button"],
        onClick: () => n && e && n(e),
        "aria-label": `Remove tag ${e}`,
        children: /* @__PURE__ */ b(
          xt,
          {
            name: "Close",
            className: Ee["filter-tag__button__close-icon"]
          }
        )
      }
    )
  ] })
), Ye = {
  "search-input": "elo-search-input",
  "search-input__input": "elo-search-input__input",
  "search-input__button": "elo-search-input__button",
  "search-input__button__icon": "elo-search-input__button__icon",
  "search-input--no-result": "elo-search-input--no-result"
}, Pr = En(
  ({
    hasResult: e = !0,
    iconName: t,
    isSearchButton: n = !0,
    onSearchPress: r,
    onSearchClear: o,
    ...i
  }, l) => {
    const a = Ot(
      Ye["search-input"],
      !e && Ye["search-input--no-result"]
    ), s = (u) => {
      u.key === "Enter" && String(i.value ?? "").length > 0 && (r == null || r(String(i.value)), o == null || o());
    }, p = () => {
      n && (r == null || r(String(i.value))), o == null || o();
    };
    return /* @__PURE__ */ oe("div", { className: a, children: [
      /* @__PURE__ */ b(
        "input",
        {
          ref: l,
          className: Ye["search-input__input"],
          onKeyDown: s,
          ...i
        }
      ),
      /* @__PURE__ */ b(
        "button",
        {
          type: "button",
          onClick: p,
          className: Ye["search-input__button"],
          "aria-label": String(i.value).length > 0 ? "Clear search" : "Search",
          children: /* @__PURE__ */ b(
            xt,
            {
              name: t,
              height: "30",
              width: "30",
              className: Ye["search-input__button__icon"]
            }
          )
        }
      )
    ] });
  }
), Sn = m.oneOfType([m.func, m.object]);
let nn = 0;
function Tr(e) {
  const [t, n] = P.useState(e), r = e || t;
  return P.useEffect(() => {
    t == null && (nn += 1, n(`mui-${nn}`));
  }, [t]), r;
}
const Sr = {
  ...P
}, rn = Sr.useId;
function Ar(e) {
  if (rn !== void 0) {
    const t = rn();
    return e ?? t;
  }
  return Tr(e);
}
function Ct({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = P.useRef(e !== void 0), [i, l] = P.useState(t), a = o ? e : i;
  if (process.env.NODE_ENV !== "production") {
    P.useEffect(() => {
      o !== (e !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: p
    } = P.useRef(t);
    P.useEffect(() => {
      !o && !Object.is(p, t) && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const s = P.useCallback((p) => {
    o || l(p);
  }, []);
  return [a, s];
}
const Mr = (e) => {
  const t = P.useRef({});
  return P.useEffect(() => {
    t.current = e;
  }), t.current;
}, la = (e, t) => {
  sessionStorage.setItem(e, JSON.stringify(t));
}, ca = (e) => {
  try {
    const t = sessionStorage.getItem(e);
    return t ? JSON.parse(t) : null;
  } catch {
    return null;
  }
}, ua = (e) => {
  sessionStorage.removeItem(e);
}, kr = "elo-dropdown", Cr = "elo-dropdown__content", Rr = "elo-mobile", Lr = "elo-open", vt = {
  dropdown: kr,
  dropdown__content: Cr,
  mobile: Rr,
  open: Lr,
  "dropdown__content--aligned": "elo-dropdown__content--aligned"
}, fa = ({
  disabled: e = !1,
  filterIcon: t,
  filterLabel: n,
  filterSelected: r = !1,
  isLastItem: o = !1,
  children: i,
  ...l
}) => {
  const [a, s] = wt(r), p = Pn("(min-width: 1240px)"), u = or(null), v = Pe(() => {
    s((M) => !M);
  }, []), x = Pe((M) => {
    u.current && !u.current.contains(M.target) && s(!1);
  }, []);
  Et(() => (document.addEventListener("mousedown", x), () => {
    document.removeEventListener("mousedown", x);
  }), [x]);
  const d = Ot(vt.dropdown, l.className, {
    [vt.open]: a
  });
  return /* @__PURE__ */ oe("div", { ...l, className: d, ref: u, children: [
    /* @__PURE__ */ b(
      ir,
      {
        disabled: e,
        leftIcon: t,
        rightIcon: a ? "ArrowUp" : "ArrowDown",
        onClick: v,
        isDesktop: p,
        children: n
      }
    ),
    a && /* @__PURE__ */ b(
      "div",
      {
        className: Ot(vt.dropdown__content, {
          [vt["dropdown__content--aligned"]]: o
        }),
        children: i
      }
    )
  ] });
};
var ne = "top", de = "bottom", me = "right", re = "left", Vt = "auto", at = [ne, de, me, re], Fe = "start", rt = "end", Ir = "clippingParents", An = "viewport", Je = "popper", Dr = "reference", on = /* @__PURE__ */ at.reduce(function(e, t) {
  return e.concat([t + "-" + Fe, t + "-" + rt]);
}, []), Mn = /* @__PURE__ */ [].concat(at, [Vt]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Fe, t + "-" + rt]);
}, []), Nr = "beforeRead", $r = "read", jr = "afterRead", Br = "beforeMain", Vr = "main", Ur = "afterMain", Fr = "beforeWrite", Wr = "write", Hr = "afterWrite", zr = [Nr, $r, jr, Br, Vr, Ur, Fr, Wr, Hr];
function be(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function le(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Le(e) {
  var t = le(e).Element;
  return e instanceof t || e instanceof Element;
}
function pe(e) {
  var t = le(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Ut(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = le(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function qr(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, i = t.elements[n];
    !pe(i) || !be(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(l) {
      var a = o[l];
      a === !1 ? i.removeAttribute(l) : i.setAttribute(l, a === !0 ? "" : a);
    }));
  });
}
function Gr(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], i = t.attributes[r] || {}, l = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), a = l.reduce(function(s, p) {
        return s[p] = "", s;
      }, {});
      !pe(o) || !be(o) || (Object.assign(o.style, a), Object.keys(i).forEach(function(s) {
        o.removeAttribute(s);
      }));
    });
  };
}
const Kr = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: qr,
  effect: Gr,
  requires: ["computeStyles"]
};
function ve(e) {
  return e.split("-")[0];
}
var Ce = Math.max, _t = Math.min, We = Math.round;
function $t() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function kn() {
  return !/^((?!chrome|android).)*safari/i.test($t());
}
function He(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, i = 1;
  t && pe(e) && (o = e.offsetWidth > 0 && We(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && We(r.height) / e.offsetHeight || 1);
  var l = Le(e) ? le(e) : window, a = l.visualViewport, s = !kn() && n, p = (r.left + (s && a ? a.offsetLeft : 0)) / o, u = (r.top + (s && a ? a.offsetTop : 0)) / i, v = r.width / o, x = r.height / i;
  return {
    width: v,
    height: x,
    top: u,
    right: p + v,
    bottom: u + x,
    left: p,
    x: p,
    y: u
  };
}
function Ft(e) {
  var t = He(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function Cn(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Ut(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function _e(e) {
  return le(e).getComputedStyle(e);
}
function Xr(e) {
  return ["table", "td", "th"].indexOf(be(e)) >= 0;
}
function Te(e) {
  return ((Le(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Pt(e) {
  return be(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Ut(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Te(e)
  );
}
function an(e) {
  return !pe(e) || // https://github.com/popperjs/popper-core/issues/837
  _e(e).position === "fixed" ? null : e.offsetParent;
}
function Zr(e) {
  var t = /firefox/i.test($t()), n = /Trident/i.test($t());
  if (n && pe(e)) {
    var r = _e(e);
    if (r.position === "fixed")
      return null;
  }
  var o = Pt(e);
  for (Ut(o) && (o = o.host); pe(o) && ["html", "body"].indexOf(be(o)) < 0; ) {
    var i = _e(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function st(e) {
  for (var t = le(e), n = an(e); n && Xr(n) && _e(n).position === "static"; )
    n = an(n);
  return n && (be(n) === "html" || be(n) === "body" && _e(n).position === "static") ? t : n || Zr(e) || t;
}
function Wt(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function tt(e, t, n) {
  return Ce(e, _t(t, n));
}
function Qr(e, t, n) {
  var r = tt(e, t, n);
  return r > n ? n : r;
}
function Rn() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Ln(e) {
  return Object.assign({}, Rn(), e);
}
function In(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var Yr = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Ln(typeof t != "number" ? t : In(t, at));
};
function Jr(e) {
  var t, n = e.state, r = e.name, o = e.options, i = n.elements.arrow, l = n.modifiersData.popperOffsets, a = ve(n.placement), s = Wt(a), p = [re, me].indexOf(a) >= 0, u = p ? "height" : "width";
  if (!(!i || !l)) {
    var v = Yr(o.padding, n), x = Ft(i), d = s === "y" ? ne : re, M = s === "y" ? de : me, O = n.rects.reference[u] + n.rects.reference[s] - l[s] - n.rects.popper[u], w = l[s] - n.rects.reference[s], T = st(i), k = T ? s === "y" ? T.clientHeight || 0 : T.clientWidth || 0 : 0, C = O / 2 - w / 2, y = v[d], S = k - x[u] - v[M], g = k / 2 - x[u] / 2 + C, A = tt(y, g, S), B = s;
    n.modifiersData[r] = (t = {}, t[B] = A, t.centerOffset = A - g, t);
  }
}
function eo(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || Cn(t.elements.popper, o) && (t.elements.arrow = o));
}
const to = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Jr,
  effect: eo,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ze(e) {
  return e.split("-")[1];
}
var no = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function ro(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: We(n * o) / o || 0,
    y: We(r * o) / o || 0
  };
}
function sn(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, i = e.variation, l = e.offsets, a = e.position, s = e.gpuAcceleration, p = e.adaptive, u = e.roundOffsets, v = e.isFixed, x = l.x, d = x === void 0 ? 0 : x, M = l.y, O = M === void 0 ? 0 : M, w = typeof u == "function" ? u({
    x: d,
    y: O
  }) : {
    x: d,
    y: O
  };
  d = w.x, O = w.y;
  var T = l.hasOwnProperty("x"), k = l.hasOwnProperty("y"), C = re, y = ne, S = window;
  if (p) {
    var g = st(n), A = "clientHeight", B = "clientWidth";
    if (g === le(n) && (g = Te(n), _e(g).position !== "static" && a === "absolute" && (A = "scrollHeight", B = "scrollWidth")), g = g, o === ne || (o === re || o === me) && i === rt) {
      y = de;
      var j = v && g === S && S.visualViewport ? S.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        g[A]
      );
      O -= j - r.height, O *= s ? 1 : -1;
    }
    if (o === re || (o === ne || o === de) && i === rt) {
      C = me;
      var V = v && g === S && S.visualViewport ? S.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        g[B]
      );
      d -= V - r.width, d *= s ? 1 : -1;
    }
  }
  var U = Object.assign({
    position: a
  }, p && no), R = u === !0 ? ro({
    x: d,
    y: O
  }, le(n)) : {
    x: d,
    y: O
  };
  if (d = R.x, O = R.y, s) {
    var L;
    return Object.assign({}, U, (L = {}, L[y] = k ? "0" : "", L[C] = T ? "0" : "", L.transform = (S.devicePixelRatio || 1) <= 1 ? "translate(" + d + "px, " + O + "px)" : "translate3d(" + d + "px, " + O + "px, 0)", L));
  }
  return Object.assign({}, U, (t = {}, t[y] = k ? O + "px" : "", t[C] = T ? d + "px" : "", t.transform = "", t));
}
function oo(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, l = i === void 0 ? !0 : i, a = n.roundOffsets, s = a === void 0 ? !0 : a, p = {
    placement: ve(t.placement),
    variation: ze(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, sn(Object.assign({}, p, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: l,
    roundOffsets: s
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, sn(Object.assign({}, p, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const io = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: oo,
  data: {}
};
var bt = {
  passive: !0
};
function ao(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, i = o === void 0 ? !0 : o, l = r.resize, a = l === void 0 ? !0 : l, s = le(t.elements.popper), p = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && p.forEach(function(u) {
    u.addEventListener("scroll", n.update, bt);
  }), a && s.addEventListener("resize", n.update, bt), function() {
    i && p.forEach(function(u) {
      u.removeEventListener("scroll", n.update, bt);
    }), a && s.removeEventListener("resize", n.update, bt);
  };
}
const so = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: ao,
  data: {}
};
var lo = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function yt(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return lo[t];
  });
}
var co = {
  start: "end",
  end: "start"
};
function ln(e) {
  return e.replace(/start|end/g, function(t) {
    return co[t];
  });
}
function Ht(e) {
  var t = le(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function zt(e) {
  return He(Te(e)).left + Ht(e).scrollLeft;
}
function uo(e, t) {
  var n = le(e), r = Te(e), o = n.visualViewport, i = r.clientWidth, l = r.clientHeight, a = 0, s = 0;
  if (o) {
    i = o.width, l = o.height;
    var p = kn();
    (p || !p && t === "fixed") && (a = o.offsetLeft, s = o.offsetTop);
  }
  return {
    width: i,
    height: l,
    x: a + zt(e),
    y: s
  };
}
function fo(e) {
  var t, n = Te(e), r = Ht(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = Ce(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), l = Ce(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), a = -r.scrollLeft + zt(e), s = -r.scrollTop;
  return _e(o || n).direction === "rtl" && (a += Ce(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: l,
    x: a,
    y: s
  };
}
function qt(e) {
  var t = _e(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function Dn(e) {
  return ["html", "body", "#document"].indexOf(be(e)) >= 0 ? e.ownerDocument.body : pe(e) && qt(e) ? e : Dn(Pt(e));
}
function nt(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = Dn(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = le(r), l = o ? [i].concat(i.visualViewport || [], qt(r) ? r : []) : r, a = t.concat(l);
  return o ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(nt(Pt(l)))
  );
}
function jt(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function po(e, t) {
  var n = He(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function cn(e, t, n) {
  return t === An ? jt(uo(e, n)) : Le(t) ? po(t, n) : jt(fo(Te(e)));
}
function mo(e) {
  var t = nt(Pt(e)), n = ["absolute", "fixed"].indexOf(_e(e).position) >= 0, r = n && pe(e) ? st(e) : e;
  return Le(r) ? t.filter(function(o) {
    return Le(o) && Cn(o, r) && be(o) !== "body";
  }) : [];
}
function ho(e, t, n, r) {
  var o = t === "clippingParents" ? mo(e) : [].concat(t), i = [].concat(o, [n]), l = i[0], a = i.reduce(function(s, p) {
    var u = cn(e, p, r);
    return s.top = Ce(u.top, s.top), s.right = _t(u.right, s.right), s.bottom = _t(u.bottom, s.bottom), s.left = Ce(u.left, s.left), s;
  }, cn(e, l, r));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function Nn(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? ve(r) : null, i = r ? ze(r) : null, l = t.x + t.width / 2 - n.width / 2, a = t.y + t.height / 2 - n.height / 2, s;
  switch (o) {
    case ne:
      s = {
        x: l,
        y: t.y - n.height
      };
      break;
    case de:
      s = {
        x: l,
        y: t.y + t.height
      };
      break;
    case me:
      s = {
        x: t.x + t.width,
        y: a
      };
      break;
    case re:
      s = {
        x: t.x - n.width,
        y: a
      };
      break;
    default:
      s = {
        x: t.x,
        y: t.y
      };
  }
  var p = o ? Wt(o) : null;
  if (p != null) {
    var u = p === "y" ? "height" : "width";
    switch (i) {
      case Fe:
        s[p] = s[p] - (t[u] / 2 - n[u] / 2);
        break;
      case rt:
        s[p] = s[p] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return s;
}
function ot(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, i = n.strategy, l = i === void 0 ? e.strategy : i, a = n.boundary, s = a === void 0 ? Ir : a, p = n.rootBoundary, u = p === void 0 ? An : p, v = n.elementContext, x = v === void 0 ? Je : v, d = n.altBoundary, M = d === void 0 ? !1 : d, O = n.padding, w = O === void 0 ? 0 : O, T = Ln(typeof w != "number" ? w : In(w, at)), k = x === Je ? Dr : Je, C = e.rects.popper, y = e.elements[M ? k : x], S = ho(Le(y) ? y : y.contextElement || Te(e.elements.popper), s, u, l), g = He(e.elements.reference), A = Nn({
    reference: g,
    element: C,
    strategy: "absolute",
    placement: o
  }), B = jt(Object.assign({}, C, A)), j = x === Je ? B : g, V = {
    top: S.top - j.top + T.top,
    bottom: j.bottom - S.bottom + T.bottom,
    left: S.left - j.left + T.left,
    right: j.right - S.right + T.right
  }, U = e.modifiersData.offset;
  if (x === Je && U) {
    var R = U[o];
    Object.keys(V).forEach(function(L) {
      var Q = [me, de].indexOf(L) >= 0 ? 1 : -1, Z = [ne, de].indexOf(L) >= 0 ? "y" : "x";
      V[L] += R[Z] * Q;
    });
  }
  return V;
}
function go(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, i = n.rootBoundary, l = n.padding, a = n.flipVariations, s = n.allowedAutoPlacements, p = s === void 0 ? Mn : s, u = ze(r), v = u ? a ? on : on.filter(function(M) {
    return ze(M) === u;
  }) : at, x = v.filter(function(M) {
    return p.indexOf(M) >= 0;
  });
  x.length === 0 && (x = v);
  var d = x.reduce(function(M, O) {
    return M[O] = ot(e, {
      placement: O,
      boundary: o,
      rootBoundary: i,
      padding: l
    })[ve(O)], M;
  }, {});
  return Object.keys(d).sort(function(M, O) {
    return d[M] - d[O];
  });
}
function vo(e) {
  if (ve(e) === Vt)
    return [];
  var t = yt(e);
  return [ln(e), t, ln(t)];
}
function bo(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, l = n.altAxis, a = l === void 0 ? !0 : l, s = n.fallbackPlacements, p = n.padding, u = n.boundary, v = n.rootBoundary, x = n.altBoundary, d = n.flipVariations, M = d === void 0 ? !0 : d, O = n.allowedAutoPlacements, w = t.options.placement, T = ve(w), k = T === w, C = s || (k || !M ? [yt(w)] : vo(w)), y = [w].concat(C).reduce(function(H, q) {
      return H.concat(ve(q) === Vt ? go(t, {
        placement: q,
        boundary: u,
        rootBoundary: v,
        padding: p,
        flipVariations: M,
        allowedAutoPlacements: O
      }) : q);
    }, []), S = t.rects.reference, g = t.rects.popper, A = /* @__PURE__ */ new Map(), B = !0, j = y[0], V = 0; V < y.length; V++) {
      var U = y[V], R = ve(U), L = ze(U) === Fe, Q = [ne, de].indexOf(R) >= 0, Z = Q ? "width" : "height", _ = ot(t, {
        placement: U,
        boundary: u,
        rootBoundary: v,
        altBoundary: x,
        padding: p
      }), I = Q ? L ? me : re : L ? de : ne;
      S[Z] > g[Z] && (I = yt(I));
      var K = yt(I), Y = [];
      if (i && Y.push(_[R] <= 0), a && Y.push(_[I] <= 0, _[K] <= 0), Y.every(function(H) {
        return H;
      })) {
        j = U, B = !1;
        break;
      }
      A.set(U, Y);
    }
    if (B)
      for (var ge = M ? 3 : 1, ce = function(q) {
        var ue = y.find(function(he) {
          var D = A.get(he);
          if (D)
            return D.slice(0, q).every(function(F) {
              return F;
            });
        });
        if (ue)
          return j = ue, "break";
      }, te = ge; te > 0; te--) {
        var ye = ce(te);
        if (ye === "break") break;
      }
    t.placement !== j && (t.modifiersData[r]._skip = !0, t.placement = j, t.reset = !0);
  }
}
const yo = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: bo,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function un(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function fn(e) {
  return [ne, me, de, re].some(function(t) {
    return e[t] >= 0;
  });
}
function wo(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, l = ot(t, {
    elementContext: "reference"
  }), a = ot(t, {
    altBoundary: !0
  }), s = un(l, r), p = un(a, o, i), u = fn(s), v = fn(p);
  t.modifiersData[n] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: p,
    isReferenceHidden: u,
    hasPopperEscaped: v
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": v
  });
}
const Oo = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: wo
};
function xo(e, t, n) {
  var r = ve(e), o = [re, ne].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, l = i[0], a = i[1];
  return l = l || 0, a = (a || 0) * o, [re, me].indexOf(r) >= 0 ? {
    x: a,
    y: l
  } : {
    x: l,
    y: a
  };
}
function _o(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, i = o === void 0 ? [0, 0] : o, l = Mn.reduce(function(u, v) {
    return u[v] = xo(v, t.rects, i), u;
  }, {}), a = l[t.placement], s = a.x, p = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += s, t.modifiersData.popperOffsets.y += p), t.modifiersData[r] = l;
}
const Eo = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: _o
};
function Po(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Nn({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const To = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Po,
  data: {}
};
function So(e) {
  return e === "x" ? "y" : "x";
}
function Ao(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, i = o === void 0 ? !0 : o, l = n.altAxis, a = l === void 0 ? !1 : l, s = n.boundary, p = n.rootBoundary, u = n.altBoundary, v = n.padding, x = n.tether, d = x === void 0 ? !0 : x, M = n.tetherOffset, O = M === void 0 ? 0 : M, w = ot(t, {
    boundary: s,
    rootBoundary: p,
    padding: v,
    altBoundary: u
  }), T = ve(t.placement), k = ze(t.placement), C = !k, y = Wt(T), S = So(y), g = t.modifiersData.popperOffsets, A = t.rects.reference, B = t.rects.popper, j = typeof O == "function" ? O(Object.assign({}, t.rects, {
    placement: t.placement
  })) : O, V = typeof j == "number" ? {
    mainAxis: j,
    altAxis: j
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, j), U = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, R = {
    x: 0,
    y: 0
  };
  if (g) {
    if (i) {
      var L, Q = y === "y" ? ne : re, Z = y === "y" ? de : me, _ = y === "y" ? "height" : "width", I = g[y], K = I + w[Q], Y = I - w[Z], ge = d ? -B[_] / 2 : 0, ce = k === Fe ? A[_] : B[_], te = k === Fe ? -B[_] : -A[_], ye = t.elements.arrow, H = d && ye ? Ft(ye) : {
        width: 0,
        height: 0
      }, q = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Rn(), ue = q[Q], he = q[Z], D = tt(0, A[_], H[_]), F = C ? A[_] / 2 - ge - D - ue - V.mainAxis : ce - D - ue - V.mainAxis, Ie = C ? -A[_] / 2 + ge + D + he + V.mainAxis : te + D + he + V.mainAxis, Ge = t.elements.arrow && st(t.elements.arrow), ie = Ge ? y === "y" ? Ge.clientTop || 0 : Ge.clientLeft || 0 : 0, De = (L = U == null ? void 0 : U[y]) != null ? L : 0, ct = I + F - De - ie, J = I + Ie - De, E = tt(d ? _t(K, ct) : K, I, d ? Ce(Y, J) : Y);
      g[y] = E, R[y] = E - I;
    }
    if (a) {
      var ut, W = y === "x" ? ne : re, Ne = y === "x" ? de : me, fe = g[S], Se = S === "y" ? "height" : "width", Ae = fe + w[W], we = fe - w[Ne], $e = [ne, re].indexOf(T) !== -1, ft = (ut = U == null ? void 0 : U[S]) != null ? ut : 0, Ke = $e ? Ae : fe - A[Se] - B[Se] - ft + V.altAxis, Xe = $e ? fe + A[Se] + B[Se] - ft - V.altAxis : we, ee = d && $e ? Qr(Ke, fe, Xe) : tt(d ? Ke : Ae, fe, d ? Xe : we);
      g[S] = ee, R[S] = ee - fe;
    }
    t.modifiersData[r] = R;
  }
}
const Mo = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Ao,
  requiresIfExists: ["offset"]
};
function ko(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Co(e) {
  return e === le(e) || !pe(e) ? Ht(e) : ko(e);
}
function Ro(e) {
  var t = e.getBoundingClientRect(), n = We(t.width) / e.offsetWidth || 1, r = We(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function Lo(e, t, n) {
  n === void 0 && (n = !1);
  var r = pe(t), o = pe(t) && Ro(t), i = Te(t), l = He(e, o, n), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((be(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  qt(i)) && (a = Co(t)), pe(t) ? (s = He(t, !0), s.x += t.clientLeft, s.y += t.clientTop) : i && (s.x = zt(i))), {
    x: l.left + a.scrollLeft - s.x,
    y: l.top + a.scrollTop - s.y,
    width: l.width,
    height: l.height
  };
}
function Io(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var l = [].concat(i.requires || [], i.requiresIfExists || []);
    l.forEach(function(a) {
      if (!n.has(a)) {
        var s = t.get(a);
        s && o(s);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function Do(e) {
  var t = Io(e);
  return zr.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function No(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function $o(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var pn = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function dn() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function jo(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, i = o === void 0 ? pn : o;
  return function(a, s, p) {
    p === void 0 && (p = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, pn, i),
      modifiersData: {},
      elements: {
        reference: a,
        popper: s
      },
      attributes: {},
      styles: {}
    }, v = [], x = !1, d = {
      state: u,
      setOptions: function(T) {
        var k = typeof T == "function" ? T(u.options) : T;
        O(), u.options = Object.assign({}, i, u.options, k), u.scrollParents = {
          reference: Le(a) ? nt(a) : a.contextElement ? nt(a.contextElement) : [],
          popper: nt(s)
        };
        var C = Do($o([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = C.filter(function(y) {
          return y.enabled;
        }), M(), d.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!x) {
          var T = u.elements, k = T.reference, C = T.popper;
          if (dn(k, C)) {
            u.rects = {
              reference: Lo(k, st(C), u.options.strategy === "fixed"),
              popper: Ft(C)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(V) {
              return u.modifiersData[V.name] = Object.assign({}, V.data);
            });
            for (var y = 0; y < u.orderedModifiers.length; y++) {
              if (u.reset === !0) {
                u.reset = !1, y = -1;
                continue;
              }
              var S = u.orderedModifiers[y], g = S.fn, A = S.options, B = A === void 0 ? {} : A, j = S.name;
              typeof g == "function" && (u = g({
                state: u,
                options: B,
                name: j,
                instance: d
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: No(function() {
        return new Promise(function(w) {
          d.forceUpdate(), w(u);
        });
      }),
      destroy: function() {
        O(), x = !0;
      }
    };
    if (!dn(a, s))
      return d;
    d.setOptions(p).then(function(w) {
      !x && p.onFirstUpdate && p.onFirstUpdate(w);
    });
    function M() {
      u.orderedModifiers.forEach(function(w) {
        var T = w.name, k = w.options, C = k === void 0 ? {} : k, y = w.effect;
        if (typeof y == "function") {
          var S = y({
            state: u,
            name: T,
            instance: d,
            options: C
          }), g = function() {
          };
          v.push(S || g);
        }
      });
    }
    function O() {
      v.forEach(function(w) {
        return w();
      }), v = [];
    }
    return d;
  };
}
var Bo = [so, To, io, Kr, Eo, yo, Mo, to, Oo], Vo = /* @__PURE__ */ jo({
  defaultModifiers: Bo
});
const $n = "Popper";
function Uo(e) {
  return sr($n, e);
}
ar($n, ["root"]);
function Fo(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function it(e) {
  return typeof e == "function" ? e() : e;
}
function lt(e) {
  return e.nodeType !== void 0;
}
function jn(e) {
  return !lt(e);
}
const Wo = () => ur({
  root: ["root"]
}, fr(Uo)), Ho = {}, Bn = /* @__PURE__ */ P.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: o,
    direction: i,
    disablePortal: l,
    modifiers: a,
    open: s,
    placement: p,
    popperOptions: u,
    popperRef: v,
    slotProps: x = {},
    slots: d = {},
    TransitionProps: M,
    // @ts-ignore internal logic
    ownerState: O,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...w
  } = t, T = P.useRef(null), k = en(T, n), C = P.useRef(null), y = en(C, v), S = P.useRef(y);
  tn(() => {
    S.current = y;
  }, [y]), P.useImperativeHandle(v, () => C.current, []);
  const g = Fo(p, i), [A, B] = P.useState(g), [j, V] = P.useState(it(r));
  P.useEffect(() => {
    C.current && C.current.forceUpdate();
  }), P.useEffect(() => {
    r && V(it(r));
  }, [r]), tn(() => {
    if (!j || !s)
      return;
    const Z = (K) => {
      B(K.placement);
    };
    if (process.env.NODE_ENV !== "production" && j && lt(j) && j.nodeType === 1) {
      const K = j.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && K.top === 0 && K.left === 0 && K.right === 0 && K.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let _ = [{
      name: "preventOverflow",
      options: {
        altBoundary: l
      }
    }, {
      name: "flip",
      options: {
        altBoundary: l
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: K
      }) => {
        Z(K);
      }
    }];
    a != null && (_ = _.concat(a)), u && u.modifiers != null && (_ = _.concat(u.modifiers));
    const I = Vo(j, T.current, {
      placement: g,
      ...u,
      modifiers: _
    });
    return S.current(I), () => {
      I.destroy(), S.current(null);
    };
  }, [j, l, a, s, u, g]);
  const U = {
    placement: A
  };
  M !== null && (U.TransitionProps = M);
  const R = Wo(), L = d.root ?? "div", Q = cr({
    elementType: L,
    externalSlotProps: x.root,
    externalForwardedProps: w,
    additionalProps: {
      role: "tooltip",
      ref: k
    },
    ownerState: t,
    className: R.root
  });
  return /* @__PURE__ */ b(L, {
    ...Q,
    children: typeof o == "function" ? o(U) : o
  });
});
process.env.NODE_ENV !== "production" && (Bn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: Tn(m.oneOfType([Dt, m.object, m.func]), (e) => {
    if (e.open) {
      const t = it(e.anchorEl);
      if (t && lt(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || jn(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: m.oneOfType([m.node, m.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: m.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: m.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: m.arrayOf(m.shape({
    data: m.object,
    effect: m.func,
    enabled: m.bool,
    fn: m.func,
    name: m.any,
    options: m.object,
    phase: m.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: m.arrayOf(m.string),
    requiresIfExists: m.arrayOf(m.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: m.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: m.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: m.shape({
    modifiers: m.array,
    onFirstUpdate: m.func,
    placement: m.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: m.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Sn,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: m.shape({
    root: m.oneOfType([m.func, m.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: m.shape({
    root: m.elementType
  }),
  TransitionProps: m.object
});
const Vn = /* @__PURE__ */ P.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: o,
    container: i,
    direction: l = "ltr",
    disablePortal: a = !1,
    keepMounted: s = !1,
    modifiers: p,
    open: u,
    placement: v = "bottom",
    popperOptions: x = Ho,
    popperRef: d,
    style: M,
    transition: O = !1,
    slotProps: w = {},
    slots: T = {},
    ...k
  } = t, [C, y] = P.useState(!0), S = () => {
    y(!1);
  }, g = () => {
    y(!0);
  };
  if (!s && !u && (!O || C))
    return null;
  let A;
  if (i)
    A = i;
  else if (r) {
    const V = it(r);
    A = V && lt(V) ? Jt(V).body : Jt(null).body;
  }
  const B = !u && s && (!O || C) ? "none" : void 0, j = O ? {
    in: u,
    onEnter: S,
    onExited: g
  } : void 0;
  return /* @__PURE__ */ b(lr, {
    disablePortal: a,
    container: A,
    children: /* @__PURE__ */ b(Bn, {
      anchorEl: r,
      direction: l,
      disablePortal: a,
      modifiers: p,
      ref: n,
      open: O ? !C : u,
      placement: v,
      popperOptions: x,
      popperRef: d,
      slotProps: w,
      slots: T,
      ...k,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: B,
        ...M
      },
      TransitionProps: j,
      children: o
    })
  });
});
process.env.NODE_ENV !== "production" && (Vn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: Tn(m.oneOfType([Dt, m.object, m.func]), (e) => {
    if (e.open) {
      const t = it(e.anchorEl);
      if (t && lt(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || jn(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: m.oneOfType([m.node, m.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: m.oneOfType([Dt, m.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: m.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: m.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: m.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: m.arrayOf(m.shape({
    data: m.object,
    effect: m.func,
    enabled: m.bool,
    fn: m.func,
    name: m.any,
    options: m.object,
    phase: m.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: m.arrayOf(m.string),
    requiresIfExists: m.arrayOf(m.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: m.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: m.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: m.shape({
    modifiers: m.array,
    onFirstUpdate: m.func,
    placement: m.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: m.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Sn,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: m.shape({
    root: m.oneOfType([m.func, m.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: m.shape({
    root: m.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: m.bool
});
function mn(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function zo(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: n = !0,
    limit: r,
    matchFrom: o = "any",
    stringify: i,
    trim: l = !1
  } = e;
  return (a, {
    inputValue: s,
    getOptionLabel: p
  }) => {
    let u = l ? s.trim() : s;
    n && (u = u.toLowerCase()), t && (u = mn(u));
    const v = u ? a.filter((x) => {
      let d = (i || p)(x);
      return n && (d = d.toLowerCase()), t && (d = mn(d)), o === "start" ? d.startsWith(u) : d.includes(u);
    }) : a;
    return typeof r == "number" ? v.slice(0, r) : v;
  };
}
const qo = zo(), hn = 5, Go = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
}, Ko = [];
function Xo(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = Go,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: n = "Mui",
    autoComplete: r = !1,
    autoHighlight: o = !1,
    autoSelect: i = !1,
    blurOnSelect: l = !1,
    clearOnBlur: a = !e.freeSolo,
    clearOnEscape: s = !1,
    componentName: p = "useAutocomplete",
    defaultValue: u = e.multiple ? Ko : null,
    disableClearable: v = !1,
    disableCloseOnSelect: x = !1,
    disabled: d,
    disabledItemsFocusable: M = !1,
    disableListWrap: O = !1,
    filterOptions: w = qo,
    filterSelectedOptions: T = !1,
    freeSolo: k = !1,
    getOptionDisabled: C,
    getOptionKey: y,
    getOptionLabel: S = (f) => f.label ?? f,
    groupBy: g,
    handleHomeEndKeys: A = !e.freeSolo,
    id: B,
    includeInputInList: j = !1,
    inputValue: V,
    isOptionEqualToValue: U = (f, c) => f === c,
    multiple: R = !1,
    onChange: L,
    onClose: Q,
    onHighlightChange: Z,
    onInputChange: _,
    onOpen: I,
    open: K,
    openOnFocus: Y = !1,
    options: ge,
    readOnly: ce = !1,
    selectOnFocus: te = !e.freeSolo,
    value: ye
  } = e, H = Ar(B);
  let q = S;
  q = (f) => {
    const c = S(f);
    if (typeof c != "string") {
      if (process.env.NODE_ENV !== "production") {
        const h = c === void 0 ? "undefined" : `${typeof c} (${c})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${p} returned ${h} instead of a string for ${JSON.stringify(f)}.`);
      }
      return String(c);
    }
    return c;
  };
  const ue = P.useRef(!1), he = P.useRef(!0), D = P.useRef(null), F = P.useRef(null), [Ie, Ge] = P.useState(null), [ie, De] = P.useState(-1), ct = o ? 0 : -1, J = P.useRef(ct), [E, ut] = Ct({
    controlled: ye,
    default: u,
    name: p
  }), [W, Ne] = Ct({
    controlled: V,
    default: "",
    name: p,
    state: "inputValue"
  }), [fe, Se] = P.useState(!1), Ae = P.useCallback((f, c, h) => {
    if (!(R ? E.length < c.length : c !== null) && !a)
      return;
    let $;
    if (R)
      $ = "";
    else if (c == null)
      $ = "";
    else {
      const z = q(c);
      $ = typeof z == "string" ? z : "";
    }
    W !== $ && (Ne($), _ && _(f, $, h));
  }, [q, W, R, _, Ne, a, E]), [we, $e] = Ct({
    controlled: K,
    default: !1,
    name: p,
    state: "open"
  }), [ft, Ke] = P.useState(!0), Xe = !R && E != null && W === q(E), ee = we && !ce, G = ee ? w(
    ge.filter((f) => !(T && (R ? E : [E]).some((c) => c !== null && U(f, c)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: Xe && ft ? "" : W,
      getOptionLabel: q
    }
  ) : [], Oe = Mr({
    filteredOptions: G,
    value: E,
    inputValue: W
  });
  P.useEffect(() => {
    const f = E !== Oe.value;
    fe && !f || k && !f || Ae(null, E, "reset");
  }, [E, Ae, fe, Oe.value, k]);
  const St = we && G.length > 0 && !ce;
  if (process.env.NODE_ENV !== "production" && E !== null && !k && ge.length > 0) {
    const f = (R ? E : [E]).filter((c) => !ge.some((h) => U(h, c)));
    f.length > 0 && console.warn([`MUI: The value provided to ${p} is invalid.`, `None of the options match with \`${f.length > 1 ? JSON.stringify(f) : JSON.stringify(f[0])}\`.`, "You can use the `isOptionEqualToValue` prop to customize the equality test."].join(`
`));
  }
  const pt = gt((f) => {
    f === -1 ? D.current.focus() : Ie.querySelector(`[data-tag-index="${f}"]`).focus();
  });
  P.useEffect(() => {
    R && ie > E.length - 1 && (De(-1), pt(-1));
  }, [E, R, ie, pt]);
  function Wn(f, c) {
    if (!F.current || f < 0 || f >= G.length)
      return -1;
    let h = f;
    for (; ; ) {
      const N = F.current.querySelector(`[data-option-index="${h}"]`), $ = M ? !1 : !N || N.disabled || N.getAttribute("aria-disabled") === "true";
      if (N && N.hasAttribute("tabindex") && !$)
        return h;
      if (c === "next" ? h = (h + 1) % G.length : h = (h - 1 + G.length) % G.length, h === f)
        return -1;
    }
  }
  const Me = gt(({
    event: f,
    index: c,
    reason: h = "auto"
  }) => {
    if (J.current = c, c === -1 ? D.current.removeAttribute("aria-activedescendant") : D.current.setAttribute("aria-activedescendant", `${H}-option-${c}`), Z && Z(f, c === -1 ? null : G[c], h), !F.current)
      return;
    const N = F.current.querySelector(`[role="option"].${n}-focused`);
    N && (N.classList.remove(`${n}-focused`), N.classList.remove(`${n}-focusVisible`));
    let $ = F.current;
    if (F.current.getAttribute("role") !== "listbox" && ($ = F.current.parentElement.querySelector('[role="listbox"]')), !$)
      return;
    if (c === -1) {
      $.scrollTop = 0;
      return;
    }
    const z = F.current.querySelector(`[data-option-index="${c}"]`);
    if (z && (z.classList.add(`${n}-focused`), h === "keyboard" && z.classList.add(`${n}-focusVisible`), $.scrollHeight > $.clientHeight && h !== "mouse" && h !== "touch")) {
      const X = z, ae = $.clientHeight + $.scrollTop, mt = X.offsetTop + X.offsetHeight;
      mt > ae ? $.scrollTop = mt - $.clientHeight : X.offsetTop - X.offsetHeight * (g ? 1.3 : 0) < $.scrollTop && ($.scrollTop = X.offsetTop - X.offsetHeight * (g ? 1.3 : 0));
    }
  }), xe = gt(({
    event: f,
    diff: c,
    direction: h = "next",
    reason: N = "auto"
  }) => {
    if (!ee)
      return;
    const z = Wn((() => {
      const X = G.length - 1;
      if (c === "reset")
        return ct;
      if (c === "start")
        return 0;
      if (c === "end")
        return X;
      const ae = J.current + c;
      return ae < 0 ? ae === -1 && j ? -1 : O && J.current !== -1 || Math.abs(c) > 1 ? 0 : X : ae > X ? ae === X + 1 && j ? -1 : O || Math.abs(c) > 1 ? X : 0 : ae;
    })(), h);
    if (Me({
      index: z,
      reason: N,
      event: f
    }), r && c !== "reset")
      if (z === -1)
        D.current.value = W;
      else {
        const X = q(G[z]);
        D.current.value = X, X.toLowerCase().indexOf(W.toLowerCase()) === 0 && W.length > 0 && D.current.setSelectionRange(W.length, X.length);
      }
  }), Hn = () => {
    const f = (c, h) => {
      const N = c ? q(c) : "", $ = h ? q(h) : "";
      return N === $;
    };
    if (J.current !== -1 && Oe.filteredOptions && Oe.filteredOptions.length !== G.length && Oe.inputValue === W && (R ? E.length === Oe.value.length && Oe.value.every((c, h) => q(E[h]) === q(c)) : f(Oe.value, E))) {
      const c = Oe.filteredOptions[J.current];
      if (c)
        return G.findIndex((h) => q(h) === q(c));
    }
    return -1;
  }, At = P.useCallback(() => {
    if (!ee)
      return;
    const f = Hn();
    if (f !== -1) {
      J.current = f;
      return;
    }
    const c = R ? E[0] : E;
    if (G.length === 0 || c == null) {
      xe({
        diff: "reset"
      });
      return;
    }
    if (F.current) {
      if (c != null) {
        const h = G[J.current];
        if (R && h && E.findIndex(($) => U(h, $)) !== -1)
          return;
        const N = G.findIndex(($) => U($, c));
        N === -1 ? xe({
          diff: "reset"
        }) : Me({
          index: N
        });
        return;
      }
      if (J.current >= G.length - 1) {
        Me({
          index: G.length - 1
        });
        return;
      }
      Me({
        index: J.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    G.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    R ? !1 : E,
    T,
    xe,
    Me,
    ee,
    W,
    R
  ]), zn = gt((f) => {
    pr(F, f), f && At();
  });
  process.env.NODE_ENV !== "production" && P.useEffect(() => {
    (!D.current || D.current.nodeName !== "INPUT") && (D.current && D.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${p} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${D.current} while an HTMLInputElement was expected.`, `Instead, ${p} expects an input element.`, "", p === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [p]), P.useEffect(() => {
    At();
  }, [At]);
  const ke = (f) => {
    we || ($e(!0), Ke(!0), I && I(f));
  }, Ze = (f, c) => {
    we && ($e(!1), Q && Q(f, c));
  }, je = (f, c, h, N) => {
    if (R) {
      if (E.length === c.length && E.every(($, z) => $ === c[z]))
        return;
    } else if (E === c)
      return;
    L && L(f, c, h, N), ut(c);
  }, dt = P.useRef(!1), Qe = (f, c, h = "selectOption", N = "options") => {
    let $ = h, z = c;
    if (R) {
      if (z = Array.isArray(E) ? E.slice() : [], process.env.NODE_ENV !== "production") {
        const ae = z.filter((mt) => U(c, mt));
        ae.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${p} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${ae.length} matches.`].join(`
`));
      }
      const X = z.findIndex((ae) => U(c, ae));
      X === -1 ? z.push(c) : N !== "freeSolo" && (z.splice(X, 1), $ = "removeOption");
    }
    Ae(f, z, $), je(f, z, $, {
      option: c
    }), !x && (!f || !f.ctrlKey && !f.metaKey) && Ze(f, $), (l === !0 || l === "touch" && dt.current || l === "mouse" && !dt.current) && D.current.blur();
  };
  function qn(f, c) {
    if (f === -1)
      return -1;
    let h = f;
    for (; ; ) {
      if (c === "next" && h === E.length || c === "previous" && h === -1)
        return -1;
      const N = Ie.querySelector(`[data-tag-index="${h}"]`);
      if (!N || !N.hasAttribute("tabindex") || N.disabled || N.getAttribute("aria-disabled") === "true")
        h += c === "next" ? 1 : -1;
      else
        return h;
    }
  }
  const Gt = (f, c) => {
    if (!R)
      return;
    W === "" && Ze(f, "toggleInput");
    let h = ie;
    ie === -1 ? W === "" && c === "previous" && (h = E.length - 1) : (h += c === "next" ? 1 : -1, h < 0 && (h = 0), h === E.length && (h = -1)), h = qn(h, c), De(h), pt(h);
  }, Kt = (f) => {
    ue.current = !0, Ne(""), _ && _(f, "", "clear"), je(f, R ? [] : null, "clear");
  }, Gn = (f) => (c) => {
    if (f.onKeyDown && f.onKeyDown(c), !c.defaultMuiPrevented && (ie !== -1 && !["ArrowLeft", "ArrowRight"].includes(c.key) && (De(-1), pt(-1)), c.which !== 229))
      switch (c.key) {
        case "Home":
          ee && A && (c.preventDefault(), xe({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: c
          }));
          break;
        case "End":
          ee && A && (c.preventDefault(), xe({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: c
          }));
          break;
        case "PageUp":
          c.preventDefault(), xe({
            diff: -hn,
            direction: "previous",
            reason: "keyboard",
            event: c
          }), ke(c);
          break;
        case "PageDown":
          c.preventDefault(), xe({
            diff: hn,
            direction: "next",
            reason: "keyboard",
            event: c
          }), ke(c);
          break;
        case "ArrowDown":
          c.preventDefault(), xe({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: c
          }), ke(c);
          break;
        case "ArrowUp":
          c.preventDefault(), xe({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: c
          }), ke(c);
          break;
        case "ArrowLeft":
          Gt(c, "previous");
          break;
        case "ArrowRight":
          Gt(c, "next");
          break;
        case "Enter":
          if (J.current !== -1 && ee) {
            const h = G[J.current], N = C ? C(h) : !1;
            if (c.preventDefault(), N)
              return;
            Qe(c, h, "selectOption"), r && D.current.setSelectionRange(D.current.value.length, D.current.value.length);
          } else k && W !== "" && Xe === !1 && (R && c.preventDefault(), Qe(c, W, "createOption", "freeSolo"));
          break;
        case "Escape":
          ee ? (c.preventDefault(), c.stopPropagation(), Ze(c, "escape")) : s && (W !== "" || R && E.length > 0) && (c.preventDefault(), c.stopPropagation(), Kt(c));
          break;
        case "Backspace":
          if (R && !ce && W === "" && E.length > 0) {
            const h = ie === -1 ? E.length - 1 : ie, N = E.slice();
            N.splice(h, 1), je(c, N, "removeOption", {
              option: E[h]
            });
          }
          break;
        case "Delete":
          if (R && !ce && W === "" && E.length > 0 && ie !== -1) {
            const h = ie, N = E.slice();
            N.splice(h, 1), je(c, N, "removeOption", {
              option: E[h]
            });
          }
          break;
      }
  }, Kn = (f) => {
    Se(!0), Y && !ue.current && ke(f);
  }, Xt = (f) => {
    if (t(F)) {
      D.current.focus();
      return;
    }
    Se(!1), he.current = !0, ue.current = !1, i && J.current !== -1 && ee ? Qe(f, G[J.current], "blur") : i && k && W !== "" ? Qe(f, W, "blur", "freeSolo") : a && Ae(f, E, "blur"), Ze(f, "blur");
  }, Xn = (f) => {
    const c = f.target.value;
    W !== c && (Ne(c), Ke(!1), _ && _(f, c, "input")), c === "" ? !v && !R && je(f, null, "clear") : ke(f);
  }, Zn = (f) => {
    const c = Number(f.currentTarget.getAttribute("data-option-index"));
    J.current !== c && Me({
      event: f,
      index: c,
      reason: "mouse"
    });
  }, Qn = (f) => {
    Me({
      event: f,
      index: Number(f.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), dt.current = !0;
  }, Yn = (f) => {
    const c = Number(f.currentTarget.getAttribute("data-option-index"));
    Qe(f, G[c], "selectOption"), dt.current = !1;
  }, Jn = (f) => (c) => {
    const h = E.slice();
    h.splice(f, 1), je(c, h, "removeOption", {
      option: E[f]
    });
  }, Zt = (f) => {
    we ? Ze(f, "toggleInput") : ke(f);
  }, er = (f) => {
    f.currentTarget.contains(f.target) && f.target.getAttribute("id") !== H && f.preventDefault();
  }, tr = (f) => {
    f.currentTarget.contains(f.target) && (D.current.focus(), te && he.current && D.current.selectionEnd - D.current.selectionStart === 0 && D.current.select(), he.current = !1);
  }, nr = (f) => {
    !d && (W === "" || !we) && Zt(f);
  };
  let Mt = k && W.length > 0;
  Mt = Mt || (R ? E.length > 0 : E !== null);
  let Qt = G;
  if (g) {
    const f = /* @__PURE__ */ new Map();
    let c = !1;
    Qt = G.reduce((h, N, $) => {
      const z = g(N);
      return h.length > 0 && h[h.length - 1].group === z ? h[h.length - 1].options.push(N) : (process.env.NODE_ENV !== "production" && (f.get(z) && !c && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${p} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), c = !0), f.set(z, !0)), h.push({
        key: $,
        index: $,
        group: z,
        options: [N]
      })), h;
    }, []);
  }
  return d && fe && Xt(), {
    getRootProps: (f = {}) => ({
      "aria-owns": St ? `${H}-listbox` : null,
      ...f,
      onKeyDown: Gn(f),
      onMouseDown: er,
      onClick: tr
    }),
    getInputLabelProps: () => ({
      id: `${H}-label`,
      htmlFor: H
    }),
    getInputProps: () => ({
      id: H,
      value: W,
      onBlur: Xt,
      onFocus: Kn,
      onChange: Xn,
      onMouseDown: nr,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": ee ? "" : null,
      "aria-autocomplete": r ? "both" : "list",
      "aria-controls": St ? `${H}-listbox` : void 0,
      "aria-expanded": St,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: D,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: d
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Kt
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Zt
    }),
    getTagProps: ({
      index: f
    }) => ({
      key: f,
      "data-tag-index": f,
      tabIndex: -1,
      ...!ce && {
        onDelete: Jn(f)
      }
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${H}-listbox`,
      "aria-labelledby": `${H}-label`,
      ref: zn,
      onMouseDown: (f) => {
        f.preventDefault();
      }
    }),
    getOptionProps: ({
      index: f,
      option: c
    }) => {
      const h = (R ? E : [E]).some(($) => $ != null && U(c, $)), N = C ? C(c) : !1;
      return {
        key: (y == null ? void 0 : y(c)) ?? q(c),
        tabIndex: -1,
        role: "option",
        id: `${H}-option-${f}`,
        onMouseMove: Zn,
        onClick: Yn,
        onTouchStart: Qn,
        "data-option-index": f,
        "aria-disabled": N,
        "aria-selected": h
      };
    },
    id: H,
    inputValue: W,
    value: E,
    dirty: Mt,
    expanded: ee && Ie,
    popupOpen: ee,
    focused: fe || ie !== -1,
    anchorEl: Ie,
    setAnchorEl: Ge,
    focusedTag: ie,
    groupedOptions: Qt
  };
}
var Un = {}, Zo = "Expected a function", gn = NaN, Qo = "[object Symbol]", Yo = /^\s+|\s+$/g, Jo = /^[-+]0x[0-9a-f]+$/i, ei = /^0b[01]+$/i, ti = /^0o[0-7]+$/i, ni = parseInt, ri = typeof ht == "object" && ht && ht.Object === Object && ht, oi = typeof self == "object" && self && self.Object === Object && self, ii = ri || oi || Function("return this")(), ai = Object.prototype, si = ai.toString, li = Math.max, ci = Math.min, Rt = function() {
  return ii.Date.now();
};
function ui(e, t, n) {
  var r, o, i, l, a, s, p = 0, u = !1, v = !1, x = !0;
  if (typeof e != "function")
    throw new TypeError(Zo);
  t = vn(t) || 0, Bt(n) && (u = !!n.leading, v = "maxWait" in n, i = v ? li(vn(n.maxWait) || 0, t) : i, x = "trailing" in n ? !!n.trailing : x);
  function d(g) {
    var A = r, B = o;
    return r = o = void 0, p = g, l = e.apply(B, A), l;
  }
  function M(g) {
    return p = g, a = setTimeout(T, t), u ? d(g) : l;
  }
  function O(g) {
    var A = g - s, B = g - p, j = t - A;
    return v ? ci(j, i - B) : j;
  }
  function w(g) {
    var A = g - s, B = g - p;
    return s === void 0 || A >= t || A < 0 || v && B >= i;
  }
  function T() {
    var g = Rt();
    if (w(g))
      return k(g);
    a = setTimeout(T, O(g));
  }
  function k(g) {
    return a = void 0, x && r ? d(g) : (r = o = void 0, l);
  }
  function C() {
    a !== void 0 && clearTimeout(a), p = 0, r = s = o = a = void 0;
  }
  function y() {
    return a === void 0 ? l : k(Rt());
  }
  function S() {
    var g = Rt(), A = w(g);
    if (r = arguments, o = this, s = g, A) {
      if (a === void 0)
        return M(s);
      if (v)
        return a = setTimeout(T, t), d(s);
    }
    return a === void 0 && (a = setTimeout(T, t)), l;
  }
  return S.cancel = C, S.flush = y, S;
}
function Bt(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function fi(e) {
  return !!e && typeof e == "object";
}
function pi(e) {
  return typeof e == "symbol" || fi(e) && si.call(e) == Qo;
}
function vn(e) {
  if (typeof e == "number")
    return e;
  if (pi(e))
    return gn;
  if (Bt(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Bt(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(Yo, "");
  var n = ei.test(e);
  return n || ti.test(e) ? ni(e.slice(2), n ? 2 : 8) : Jo.test(e) ? gn : +e;
}
var di = ui, qe = {};
Object.defineProperty(qe, "__esModule", {
  value: !0
});
qe.loadGoogleMapScript = qe.isBrowser = void 0;
var Fn = typeof window < "u" && window.document;
qe.isBrowser = Fn;
var mi = function(t, n) {
  if (!Fn || typeof google < "u" && google.maps && google.maps.api)
    return Promise.resolve();
  var r = document.querySelectorAll('script[src*="'.concat(t, '"]'));
  if (r && r.length)
    return new Promise(function(l) {
      if (typeof google < "u") return l();
      r[0].addEventListener("load", function() {
        return l();
      });
    });
  var o = new URL(n);
  o.searchParams.set("callback", "__REACT_GOOGLE_AUTOCOMPLETE_CALLBACK__");
  var i = document.createElement("script");
  return i.src = o.toString(), new Promise(function(l) {
    window.__REACT_GOOGLE_AUTOCOMPLETE_CALLBACK__ = l, document.body.appendChild(i);
  });
};
qe.loadGoogleMapScript = mi;
var Tt = {};
Object.defineProperty(Tt, "__esModule", {
  value: !0
});
Tt.GOOGLE_MAP_SCRIPT_BASE_URL = void 0;
var hi = "https://maps.googleapis.com/maps/api/js";
Tt.GOOGLE_MAP_SCRIPT_BASE_URL = hi;
Object.defineProperty(Un, "__esModule", {
  value: !0
});
var gi = Un.default = Ei, se = _n, bn = bi(di), yn = qe, vi = Tt;
function bi(e) {
  return e && e.__esModule ? e : { default: e };
}
function wn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Be(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wn(Object(n), !0).forEach(function(r) {
      yi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wn(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function yi(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ve(e, t) {
  return _i(e) || xi(e, t) || Oi(e, t) || wi();
}
function wi() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Oi(e, t) {
  if (e) {
    if (typeof e == "string") return On(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return On(e, t);
  }
}
function On(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function xi(e, t) {
  var n = e && (typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"]);
  if (n != null) {
    var r = [], o = !0, i = !1, l, a;
    try {
      for (n = n.call(e); !(o = (l = n.next()).done) && (r.push(l.value), !(t && r.length === t)); o = !0)
        ;
    } catch (s) {
      i = !0, a = s;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (i) throw a;
      }
    }
    return r;
  }
}
function _i(e) {
  if (Array.isArray(e)) return e;
}
function Ei(e) {
  var t = e.apiKey, n = e.libraries, r = n === void 0 ? "places" : n, o = e.googleMapsScriptBaseUrl, i = o === void 0 ? vi.GOOGLE_MAP_SCRIPT_BASE_URL : o, l = e.debounce, a = l === void 0 ? 300 : l, s = e.options, p = s === void 0 ? {} : s, u = e.sessionToken, v = e.language, x = v ? "&language=".concat(v) : "", d = "".concat(i, "?key=").concat(t, "&libraries=").concat(r).concat(x), M = (0, se.useState)([]), O = Ve(M, 2), w = O[0], T = O[1], k = (0, se.useState)(!1), C = Ve(k, 2), y = C[0], S = C[1], g = (0, se.useState)(null), A = Ve(g, 2), B = A[0], j = A[1], V = (0, se.useState)(!1), U = Ve(V, 2), R = U[0], L = U[1], Q = (0, se.useState)(!1), Z = Ve(Q, 2), _ = Z[0], I = Z[1], K = (0, se.useState)([]), Y = Ve(K, 2), ge = Y[0], ce = Y[1], te = (0, se.useRef)(null), ye = (0, se.useRef)(null), H = (0, se.useRef)(null), q = (0, se.useCallback)(function() {
    return (0, yn.loadGoogleMapScript)(i, d);
  }, [i, d]), ue = (0, se.useCallback)((0, bn.default)(function(D) {
    te.current && D.input && te.current.getPlacePredictions(Be(Be(Be({}, u && H.current ? {
      sessionToken: H.current
    } : {}), p), D), function(F) {
      S(!1), T(F || []);
    });
  }, a), [a]), he = (0, se.useCallback)((0, bn.default)(function(D) {
    te.current && D.input && te.current.getQueryPredictions(Be(Be(Be({}, u && H.current ? {
      sessionToken: H.current
    } : {}), p), D), function(F) {
      L(!1), ce(F || []);
    });
  }, a), [a]);
  return (0, se.useEffect)(function() {
    if (yn.isBrowser) {
      var D = function() {
        if (!google) return console.error("Google has not been found. Make sure your provide apiKey prop.");
        te.current = new google.maps.places.AutocompleteService(), ye.current = new google.maps.places.PlacesService(document.createElement("div")), u && (H.current = new google.maps.places.AutocompleteSessionToken());
      };
      t ? q().then(function() {
        return D();
      }) : D();
    }
  }, []), {
    placesService: ye.current,
    autocompleteSessionToken: H.current,
    placesAutocompleteService: te.current,
    placePredictions: B ? w : [],
    isPlacePredictionsLoading: y,
    getPlacePredictions: function(F) {
      if (F.input) {
        j(F.input), S(!0), ue(F);
        return;
      }
      T([]), j(null), ue(F), S(!1);
    },
    queryPredictions: _ ? ge : [],
    isQueryPredictionsLoading: R,
    getQueryPredictions: function(F) {
      if (F.input) {
        I(F.input), L(!0), he(F);
        return;
      }
      ce([]), I(null), he(F), L(!1);
    },
    refreshSessionToken: function() {
      H.current = new google.maps.places.AutocompleteSessionToken();
    }
  };
}
const Pi = {
  "auto-complete-input": "elo-auto-complete-input"
}, Ti = "elo-tablet", Si = "elo-mobile", Lt = {
  "auto-complete-dropdown": "elo-auto-complete-dropdown",
  tablet: Ti,
  mobile: Si,
  "auto-complete-dropdown__label": "elo-auto-complete-dropdown__label",
  "auto-complete-dropdown__list": "elo-auto-complete-dropdown__list"
}, Ai = ({
  label: e,
  onOptionClick: t,
  groupedOptions: n,
  getListboxProps: r,
  getOptionProps: o,
  focussedOption: i
}) => /* @__PURE__ */ oe("div", { className: Lt["auto-complete-dropdown"], children: [
  e && /* @__PURE__ */ b("div", { className: Lt["auto-complete-dropdown__label"], children: /* @__PURE__ */ b(Ue, { type: "label", size: "medium", children: e }) }),
  /* @__PURE__ */ b(
    "ul",
    {
      ...r(),
      className: Lt["auto-complete-dropdown__list"],
      children: n.map((l, a) => {
        const s = l, p = o({ option: s, index: a }), u = (i == null ? void 0 : i.place_id) === s.place_id || (i == null ? void 0 : i.label) === s.label;
        return /* @__PURE__ */ b("li", { ...p, "aria-selected": u, children: /* @__PURE__ */ b(
          Er,
          {
            icon: "Location",
            onClick: (v) => {
              v.preventDefault(), t(s.label);
            },
            label: s.label,
            focussed: u
          }
        ) });
      })
    }
  )
] }), Mi = ({
  getRootProps: e,
  rootRef: t,
  iconName: n,
  isFocused: r,
  hasOptions: o,
  getInputProps: i,
  placeholder: l,
  isSearchButton: a,
  onSearchPress: s,
  onSearchClear: p
}) => /* @__PURE__ */ b(
  "div",
  {
    ...e(),
    ref: t,
    className: r ? "Mui-isFocused" : "",
    children: /* @__PURE__ */ b(
      Pr,
      {
        ...i(),
        iconName: n,
        hasResult: o,
        placeholder: l,
        isSearchButton: a,
        onSearchPress: s,
        onSearchClear: p
      }
    )
  }
), ki = [
  { place_id: "1", label: "Helsinki" },
  { place_id: "2", label: "Espoo" },
  { place_id: "3", label: "Vantaa" },
  { place_id: "4", label: "Turku" },
  { place_id: "5", label: "Tampere" }
], pa = ({
  googleMapApiKey: e,
  dropDownLabel: t,
  onOptionClick: n,
  cities: r = ki,
  placeholder: o,
  onSearchPress: i,
  onHandleInputChange: l,
  ...a
}) => {
  const { placePredictions: s, getPlacePredictions: p, isPlacePredictionsLoading: u } = gi({
    apiKey: e,
    options: {
      input: "",
      componentRestrictions: { country: "fi" },
      types: ["geocode"]
      // Exclude restaurants by using 'geocode' to focus on addresses and locations
    }
  }), [v, x] = P.useState(null), [d, M] = P.useState(
    a.inputValue ?? ""
  ), [O, w] = P.useState(
    null
  ), T = P.useCallback(
    (_, I) => {
      x(I), l == null || l((I == null ? void 0 : I.label) || ""), I && n(I.label);
    },
    [l, n]
  );
  P.useEffect(() => {
    d && P.startTransition(() => {
      p({ input: d });
    });
  }, [d]);
  const k = P.useCallback(
    (_, I) => {
      (_ == null ? void 0 : _.type) === "keydown" && w(I);
    },
    []
  ), {
    getRootProps: C,
    getInputProps: y,
    getListboxProps: S,
    getOptionProps: g,
    groupedOptions: A,
    focused: B,
    popupOpen: j,
    anchorEl: V,
    setAnchorEl: U
  } = Xo({
    ...a,
    options: d ? s.map((_) => ({
      place_id: _.place_id,
      label: _.description,
      postalCode: _.structured_formatting.secondary_text
    })) : r,
    value: v,
    onChange: T,
    isOptionEqualToValue: (_, I) => _.label === I.label,
    onInputChange: (_, I) => {
      M(I), l == null || l(I);
    },
    onHighlightChange: k
  }), R = j && !!V, L = y(), Q = P.useCallback(() => {
    var I, K;
    x(null), M(""), l == null || l("");
    const _ = (I = L.ref) == null ? void 0 : I.current;
    if (_) {
      _.value = "";
      const Y = new Event("change", {
        bubbles: !0
      });
      Object.defineProperty(Y, "target", { value: _ }), Object.defineProperty(Y, "currentTarget", {
        value: _
      }), (K = L.onChange) == null || K.call(L, Y);
    }
  }, [L]), Z = P.useRef(null);
  return Ci(Z), /* @__PURE__ */ oe("div", { ref: Z, className: Pi["auto-complete-input"], children: [
    /* @__PURE__ */ b(
      Mi,
      {
        iconName: R || typeof L.value == "string" && L.value.length > 0 ? "Close" : "Search",
        placeholder: o,
        getRootProps: C,
        rootRef: U,
        isFocused: B,
        getInputProps: () => ({
          ...L,
          onChange: (_) => {
            var I;
            (I = L.onChange) == null || I.call(L, _);
          }
        }),
        groupedOptions: A,
        onSearchPress: i,
        onSearchClear: Q,
        isSearchButton: !(R || typeof L.value == "string" && L.value.length > 0)
      }
    ),
    !u && A.length > 0 && /* @__PURE__ */ b(
      Vn,
      {
        open: R,
        anchorEl: V,
        placement: "bottom-start",
        disablePortal: !0,
        style: {
          zIndex: 2
        },
        children: /* @__PURE__ */ b(
          Ai,
          {
            label: typeof (L == null ? void 0 : L.value) == "string" && L.value.length === 0 ? t : "",
            getOptionProps: ({ option: _, index: I }) => g({ option: _, index: I }),
            groupedOptions: A,
            getListboxProps: S,
            onOptionClick: n,
            focussedOption: O
          }
        )
      }
    )
  ] });
};
function Ci(e) {
  P.useLayoutEffect(() => {
    const t = e == null ? void 0 : e.current;
    if (!t) return;
    const n = t.getBoundingClientRect().width;
    t.style.setProperty("--root-width", `${n}px`);
    const r = new ResizeObserver(() => {
      const o = t.getBoundingClientRect().width;
      t.style.setProperty("--root-width", `${o}px`);
    });
    return r.observe(t), () => {
      r.disconnect();
    };
  }, [e]);
}
const xn = {
  "modal-header": "elo-modal-header",
  "modal-header__close-button": "elo-modal-header__close-button"
}, Ri = ({
  heading: e,
  onClose: t
}) => /* @__PURE__ */ oe("div", { className: xn["modal-header"], children: [
  /* @__PURE__ */ b(Ue, { type: "heading", size: "small", children: e }),
  /* @__PURE__ */ b(
    Nt,
    {
      icon: "Close",
      className: xn["modal-header__close-button"],
      onClick: t
    }
  )
] }), Li = "elo-mobile", Ii = {
  "modal-footer": "elo-modal-footer",
  mobile: Li
}, Di = ({
  clearFiltersButtonText: e,
  displayResultsButtonText: t,
  disableClearButton: n,
  onClearFilters: r,
  onClose: o
}) => /* @__PURE__ */ oe("div", { className: Ii["modal-footer"], children: [
  /* @__PURE__ */ b(
    Yt,
    {
      variant: "secondary",
      onClick: r,
      disabled: n,
      children: e
    }
  ),
  /* @__PURE__ */ b(Yt, { onClick: o, children: t })
] }), Ni = "elo-modal__content", $i = "elo-modal__body", It = {
  "modal-overlay": "elo-modal-overlay",
  modal__content: Ni,
  modal__body: $i
}, da = ({
  isOpen: e,
  heading: t,
  onClose: n,
  tagIsSelected: r,
  onClearFilters: o,
  clearFiltersButtonText: i,
  displayResultsButtonText: l,
  children: a
}) => /* @__PURE__ */ b("div", { children: e && /* @__PURE__ */ b("div", { className: It["modal-overlay"], children: /* @__PURE__ */ oe("div", { className: It.modal__content, children: [
  /* @__PURE__ */ b(Ri, { heading: t, onClose: n }),
  /* @__PURE__ */ b("div", { className: It.modal__body, children: a }),
  /* @__PURE__ */ b(
    Di,
    {
      onClose: n,
      onClearFilters: o,
      disableClearButton: r,
      clearFiltersButtonText: i,
      displayResultsButtonText: l
    }
  )
] }) }) }), Re = {
  "map-view": "elo-map-view",
  "map-view__cards": "elo-map-view__cards",
  "map-view__map": "elo-map-view__map",
  "map-view__title": "elo-map-view__title",
  "map-view__card-grid": "elo-map-view__card-grid",
  "map-view__map-container": "elo-map-view__map-container",
  "map-view__info-window": "elo-map-view__info-window"
};
function ji(e) {
  const { cardText: t, cardType: n, cards: r } = e;
  return /* @__PURE__ */ oe("div", { className: Re["map-view__cards"], children: [
    n !== "apartment" && /* @__PURE__ */ oe(Ue, { type: "label", size: "large", extraClass: Re["map-view__title"], children: [
      r.length,
      " ",
      t
    ] }),
    /* @__PURE__ */ b("div", { className: Re["map-view__card-grid"], children: r.map((o, i) => n === "apartment" ? /* @__PURE__ */ b(dr, { ...o }, i) : /* @__PURE__ */ b(mr, { ...o }, i)) })
  ] });
}
const Bi = -25, Vi = 6, Ui = 5, et = 18, Fi = (e) => {
  const t = [];
  return e.forEach((n) => {
    t.push({
      lat: n.lat,
      lng: n.lng
    });
  }), t;
};
function Wi(e, { setCards: t, cardData: n }) {
  const r = Pe(() => {
    if (!e) return;
    const o = e.getBounds();
    if (!o) return;
    const l = Fi(n).map((s) => new google.maps.Marker({ position: s })).filter(
      (s) => o.contains(s.getPosition() || { lat: 0, lng: 0 })
    ).map((s) => {
      var p, u;
      return {
        lat: (p = s.getPosition()) == null ? void 0 : p.lat(),
        lng: (u = s.getPosition()) == null ? void 0 : u.lng()
      };
    }), a = n.filter(
      (s) => l.some((p) => p.lat === s.lat) && l.some((p) => p.lng === s.lng)
    );
    t(a);
  }, [n, e, t]);
  return Et(() => {
    if (!e) return;
    const o = e.addListener("zoom_changed", r);
    return () => {
      google.maps.event.removeListener(o);
    };
  }, [r, e]), r;
}
const Hi = {
  minimumClusterSize: 1,
  zoomOnClick: !1,
  styles: [
    {
      url: "/Content/Vendor/icons/map-cluster.png",
      height: 44,
      width: 44,
      anchorText: [0, 0],
      textColor: "#fff"
    },
    {
      url: "/Content/Vendor/icons/map-cluster-selected.png",
      height: 44,
      width: 44,
      textColor: "#000"
    }
  ]
};
function zi({
  activeCard: e,
  onClick: t,
  locations: n
}) {
  const r = Pe(
    (o) => qi(e, o),
    [e]
  );
  return /* @__PURE__ */ b(
    hr,
    {
      onClick: t,
      options: Hi,
      calculator: r,
      zoomOnClick: !1,
      children: (o) => /* @__PURE__ */ b(rr, { children: n.map((i, l) => /* @__PURE__ */ b(gr, { position: i, clusterer: o }, l)) })
    }
  );
}
function qi(e, t) {
  const n = t.length;
  return (e ? t.some((o) => {
    var i, l;
    return !!(o && ((i = o.getPosition()) == null ? void 0 : i.lat()) === (e == null ? void 0 : e.lat) && ((l = o.getPosition()) == null ? void 0 : l.lng()) === (e == null ? void 0 : e.lng));
  }) : !1) ? {
    text: n.toString(),
    index: 2
  } : {
    text: n.toString(),
    index: 1
  };
}
function Gi({
  activeCard: e,
  resetInfoWindow: t
}) {
  const n = Pn("(max-width: 389px)");
  return /* @__PURE__ */ b(
    vr,
    {
      position: e,
      onCloseClick: t,
      options: {
        pixelOffset: new google.maps.Size(0, Bi),
        maxWidth: n ? 250 : void 0
      },
      children: /* @__PURE__ */ b(
        _r,
        {
          url: e.apartmentPropertyUrl,
          image: e.apartmentPropertyImageUrl,
          size: "small",
          title: e.apartmentPropertyTitle,
          subtitle: e.apartmentPropertySubtitle,
          tagText: e.tagText,
          wrapperClassName: Re["map-view__info-window"]
        }
      )
    }
  );
}
function Ki({ map: e }) {
  const t = Pe(
    (n = 0) => {
      if (!e) return;
      const r = e.getZoom() ?? Vi, o = Math.max(
        Math.min(r + n, et),
        Ui
      );
      e.setZoom(o);
    },
    [e]
  );
  return /* @__PURE__ */ oe(br, { position: "LEFT_BOTTOM", children: [
    /* @__PURE__ */ b(
      Nt,
      {
        isRounded: !0,
        variant: "secondary",
        id: "zoom-in-button",
        icon: "Plus",
        onClick: () => t(1)
      }
    ),
    /* @__PURE__ */ b(
      Nt,
      {
        isRounded: !0,
        variant: "secondary",
        id: "zoom-out-button",
        icon: "Minus",
        onClick: () => t(-1)
      }
    )
  ] });
}
const Xi = {
  mapTypeControl: !1,
  streetViewControl: !1,
  fullscreenControl: !1,
  keyboardShortcuts: !1,
  zoomControl: !1,
  styles: wr,
  zoomControlOptions: { position: 15 }
  // google.maps.ControlPosition.LEFT_BOTTOM
};
function Zi(e) {
  const [t, n] = wt(null), [r, o] = wt(null), i = Wi(t, e);
  Et(() => {
    if (o(null), t) {
      const p = new google.maps.LatLngBounds();
      e.cardData.forEach((u) => {
        p.extend(new google.maps.LatLng(u.lat, u.lng));
      }), t.fitBounds(p, 100);
    }
  }, [t, e.cardData]);
  const l = Pe(
    (p) => {
      o(null);
      const { bounds: u, center: v } = p, x = p.markers, d = p.map, M = d == null ? void 0 : d.getZoom();
      if (!(!d || !M)) {
        if (M < et && d && u) {
          var O = new google.maps.LatLngBounds();
          x.forEach((T) => {
            const k = T.getPosition();
            k && O.extend(new google.maps.LatLng(k.lat(), k.lng()));
          }), d.setCenter(O.getCenter()), d.fitBounds(O);
          const w = d.getZoom();
          w && w > 1 && (d.setZoom(w - 1), w > et && d.setZoom(et));
        }
        if (x.length == 1 || M >= et) {
          const w = v == null ? void 0 : v.lat(), T = v == null ? void 0 : v.lng(), k = e.cardData.find(
            (C) => C.lat === w && C.lng === T
          );
          k && o(k);
        }
      }
    },
    [e.cardData]
  ), a = Pe(
    (p) => {
      n(p), i();
    },
    [i]
  ), s = Pe(() => o(null), []);
  return /* @__PURE__ */ b("div", { className: Re["map-view__map"], children: /* @__PURE__ */ oe(
    yr,
    {
      mapContainerClassName: Re["map-view__map-container"],
      options: Xi,
      onLoad: a,
      onZoomChanged: i,
      clickableIcons: !1,
      children: [
        /* @__PURE__ */ b(
          zi,
          {
            activeCard: r,
            locations: e.cardData,
            onClick: l
          }
        ),
        r ? /* @__PURE__ */ b(
          Gi,
          {
            activeCard: r,
            resetInfoWindow: s
          }
        ) : null,
        /* @__PURE__ */ b(Ki, { map: t })
      ]
    }
  ) });
}
function ma(e) {
  const { isLoaded: t, loadError: n } = Or({
    googleMapsApiKey: e.googleMapsApiKey
  });
  return n ? /* @__PURE__ */ b("div", { title: n.message, children: "Error loading maps" }) : t ? /* @__PURE__ */ b(Qi, { ...e }) : /* @__PURE__ */ b(xr, {});
}
function Qi(e) {
  const { cardData: t, cardText: n, cardType: r } = e, [o, i] = wt(() => t);
  return Et(() => {
    i(t);
  }, [t]), /* @__PURE__ */ oe("div", { className: Re["map-view"], children: [
    /* @__PURE__ */ b(ji, { cardText: n, cardType: r, cards: o }),
    /* @__PURE__ */ b(Zi, { setCards: i, cardData: t })
  ] });
}
export {
  pa as A,
  fa as D,
  Er as F,
  ma as M,
  Pr as S,
  sa as a,
  da as b,
  ca as g,
  ua as r,
  la as s
};
